export const expoOut = 'cubic-bezier(0.16, 1, 0.3, 1)'
